import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-jamba',
  templateUrl: './jamba.component.html',
  styleUrls: ['./jamba.component.scss']
})
export class JambaComponent {
  constructor(private dialogRef: MatDialogRef<JambaComponent>) {}

  close() {
    this.dialogRef.close();
  }
}
